module.exports = __webpack_public_path__ + "static/media/workloads-activity-stream.200e9fa3.mp4";